import React from "react";
import { useSelector } from "react-redux";
import FleetCarIcon from "assets/svgIcons/CarIcon";
import CarBehindPaceIcon from "assets/svgIcons/AdminDashboard/CarBehindPaceIcon";
import { useTranslation } from "react-i18next";

export const CarBehindPace = () => {
  const { t } = useTranslation();

  const {
    carBehindPaceData
  } = useSelector((state) => state.commonReducers);

  return (
    <>
      <div className="header">
        <FleetCarIcon color="#666" />
        <p>{t("Car_Behind_Pace")}</p>
      </div>
      <div className="box-body">
        <CarBehindPaceIcon />
        <h2 className="bp-heading">
          {carBehindPaceData && carBehindPaceData.length}
        </h2>
        <p className="bp-sub-heading">{t("Cars_Behind_Pace")}</p>
      </div>
    </>
  );
};
